<template>
    <Head title="تیکت جدید"/>
    <dashboard>
        <template v-slot:breadcrumb>
            <breadcrumb :links="[{title: 'تیکت‌ها', url: '/dashboard/tickets'}, {title: 'تیکت جدید'}]"/>
        </template>

        <form @submit.prevent="submitForm">
            <div class="shadow p-4 rounded">
                <h1 class="h2 mb-4 fw-bolder">ایجاد تیکت جدید</h1>
                <div class="row g-4">
                    <div class="col-lg-6">
                        <div class="position-relative">
                            <svg class="position-absolute top-50 start-0 translate-middle-y ms-3" width="24" height="24"
                                 viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.69628 9.05793H14.7279M8.69628 12.5141H12.5346M13.1107 18.9268H14.1721C17.0589 18.9268 19.5701 16.8499 20.2476 13.9021C20.5841 12.4382 20.5841 10.9113 20.2476 9.44741L20.1588 9.06088C19.5057 6.21958 17.377 4.01204 14.6641 3.36264L14.283 3.27141C12.7712 2.90953 11.2013 2.90953 9.68953 3.27141L9.46648 3.32481C6.65677 3.99738 4.45212 6.28371 3.77571 9.22642C3.40585 10.8355 3.40923 12.5287 3.77909 14.1378C4.46607 17.1265 6.48688 19.6138 9.19777 20.7728L9.31593 20.8233C10.489 21.3249 11.8329 20.7208 12.3142 19.4902C12.4467 19.1515 12.7622 18.9268 13.1107 18.9268Z"
                                    stroke="#6C757D" stroke-width="1.5" stroke-linecap="round"></path>
                            </svg>

                            <input v-model="form.title" type="text" class="form-control form-control-lg ps-5"
                                   placeholder="عنوان تیکت">

                        </div>
                        <div v-if="form.errors.title" class="invalid-feedback d-block fw-bold mt-2">
                            {{ form.errors.title }}
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="position-relative">
                            <svg class="position-absolute top-50 start-0 translate-middle-y ms-3" width="24" height="24"
                                 viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M3 18.433C3 16.4308 4.45485 14.7254 6.43204 14.4098L6.61013 14.3814C8.19336 14.1287 9.80664 14.1287 11.3899 14.3814L11.568 14.4098C13.5451 14.7254 15 16.4308 15 18.433C15 19.2984 14.2984 20 13.433 20H4.56697C3.70156 20 3 19.2984 3 18.433Z"
                                    stroke="#6C757D" stroke-width="1.5"/>
                                <path
                                    d="M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z"
                                    stroke="#6C757D" stroke-width="1.5"/>
                                <path
                                    d="M15 11C16.933 11 18.5 9.433 18.5 7.5C18.5 5.567 16.933 4 15 4M17.3899 20H19.433C20.2984 20 21 19.2984 21 18.433C21 16.4308 19.5451 14.7254 17.568 14.4098V14.4098C17.4494 14.3909 17.3293 14.3814 17.2093 14.3814C16.8895 14.3814 16.7902 14.3814 16.2412 14.3814"
                                    stroke="#6C757D" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>
                            <select v-model="form.department" class="form-select form-select-lg ps-5">
                                <option :value="null">دپارتمان</option>
                                <option v-for="department in departments" :value="department.id">{{ department.title }}</option>
                            </select>
                        </div>
                        <div v-if="form.errors.department" class="invalid-feedback d-block fw-bold mt-2">
                            {{ form.errors.department }}
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="position-relative">
                            <svg class="position-absolute top-50 start-0 translate-middle-y ms-3" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M3.20258 8.70024H20.7974M2.88539 15.1513C2.37154 13.0819 2.37154 10.9181 2.88539 8.84875C3.55805 6.13983 5.70602 4.04534 8.43056 3.44162L8.88443 3.34105C10.9366 2.88632 13.0634 2.88632 15.1156 3.34105L15.5694 3.44162C18.294 4.04534 20.442 6.13984 21.1146 8.84875C21.6285 10.9182 21.6285 13.0819 21.1146 15.1512C20.442 17.8602 18.294 19.9547 15.5694 20.5584L15.1156 20.659C13.0634 21.1137 10.9366 21.1137 8.88443 20.659L8.43056 20.5584C5.70601 19.9547 3.55805 17.8602 2.88539 15.1513Z"
                                    stroke="#6C757D" stroke-width="1.5"></path>
                                <path d="M7 12L11 12" stroke="#6C757D" stroke-width="1.5"
                                      stroke-linecap="round"></path>
                            </svg>
                            <select v-model="form.bill_item_id" class="form-select form-select-lg ps-5">
                                <option :value="null">سفارش مرتبط</option>
                                <option v-for="billItem in billItems.data" :value="billItem.id">سفارش {{ billItem.bill.tracking_code }} - {{ billItem.description.product_title }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <textarea v-model="form.message" class="form-control form-control-lg" rows="10" placeholder="متن تیکت"></textarea>
                        <div v-if="form.errors.message" class="invalid-feedback d-block fw-bold mt-2">
                            {{ form.errors.message }}
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <input @change="form.attachments = $event.target.files" class="form-control form-control-lg" type="file" multiple placeholder="فایل‌های ضمیمه">
                        <div class="d-block fw-bold mt-2 text-dark">
                            در این قسمت حداکثر ۳ عکس با حداکثر حجم ۱ مگابایت می‌توانید آپلود کنید.
                        </div>
                        <div v-if="form.errors.attachments" class="invalid-feedback d-block fw-bold mt-2">
                            {{ form.errors.attachments }}
                        </div>
                        <div v-for="errorKey in Object.keys(form.errors).filter(i => i.startsWith('attachments.'))" class="invalid-feedback d-block fw-bold mt-2">
                            {{ form.errors[errorKey] }}
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <button type="submit" :disabled="form.processing"
                                class="btn btn-primary bg-gradient-primary border-0 text-white btn-lg fw-bold fs-6 py-3 px-5">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M3.35288 8.95043C4.00437 6.17301 6.17301 4.00437 8.95043 3.35288C10.9563 2.88237 13.0437 2.88237 15.0496 3.35288C17.827 4.00437 19.9956 6.17301 20.6471 8.95044C21.1176 10.9563 21.1176 13.0437 20.6471 15.0496C19.9956 17.827 17.827 19.9956 15.0496 20.6471C13.0437 21.1176 10.9563 21.1176 8.95044 20.6471C6.17301 19.9956 4.00437 17.827 3.35288 15.0496C2.88237 13.0437 2.88237 10.9563 3.35288 8.95043Z"
                                    stroke="currentColor" stroke-width="1.5"/>
                                <path d="M14.5 12H9.5M12 14.5L12 9.5" stroke="currentColor" stroke-width="1.5"
                                      stroke-linecap="round"/>
                            </svg>
                            ایجاد تیکت
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </dashboard>
</template>

<script>
import Dashboard from "../../Layouts/Dashboard";
import Breadcrumb from "../../Components/Breadcrumb";
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';

export default {
    components: {
        Dashboard,
        Breadcrumb,
        Head,
        Link,
    },
    props: {
        departments: Array,
        billItems: Object,
    },
    setup(){
        const form = useForm({
            title: null,
            department: null,
            message: null,
            bill_item_id: null,
            attachments: [],
        })

        const submitForm = () => {
            form.post('/dashboard/tickets')
        }

        return {form, submitForm}
    }
}
</script>

<style scoped>

</style>
